import React from 'react';
import './ToastNotification.css';

export default function ToastNotification({ toast, onClose }) {
  if (!toast) return null;

  return (
    <div 
      className={`toast-notification ${toast.type}`}
      style={{
        position: 'fixed',
        top: '20px',
        right: '20px',
        backgroundColor: toast.type === 'success' ? '#10b981' : '#ef4444',
        color: 'white',
        padding: '1.5rem',
        borderRadius: '12px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
        zIndex: 1000000,
        maxWidth: '500px',
        animation: 'slideIn 0.3s ease-out',
        fontFamily: 'Inter, system-ui, -apple-system, sans-serif'
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '1rem' }}>
        <div style={{ flex: 1 }}>
          <strong style={{ display: 'block', marginBottom: '0.75rem', fontSize: '1.1rem' }}>
            {toast.type === 'success' ? '✓ Erfolgreich hochgeladen' : '✗ Fehler beim Upload'}
          </strong>
          <div style={{ fontSize: '0.95rem', lineHeight: '1.6', whiteSpace: 'pre-line', marginBottom: toast.link ? '0.75rem' : '0' }}>
            {toast.message}
          </div>
          {toast.link && (
            <div style={{ marginTop: '0.75rem', paddingTop: '0.75rem', borderTop: '1px solid rgba(255,255,255,0.3)' }}>
              <div style={{ fontSize: '0.85rem', marginBottom: '0.5rem', opacity: 0.9 }}>
                <strong>OneDrive-Link:</strong>
              </div>
              <a 
                href={toast.link} 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ 
                  color: 'white', 
                  textDecoration: 'underline', 
                  display: 'block',
                  wordBreak: 'break-all',
                  fontSize: '0.9rem',
                  lineHeight: '1.4'
                }}
              >
                {toast.link}
              </a>
              <div style={{ fontSize: '0.85rem', marginTop: '0.5rem', opacity: 0.9, fontStyle: 'italic' }}>
                Bitte füge das Dokument dem passenden Ordner in OneDrive/SharePoint hinzu.
              </div>
            </div>
          )}
        </div>
        <button
          onClick={onClose}
          style={{
            background: 'transparent',
            border: 'none',
            color: 'white',
            fontSize: '1.5rem',
            cursor: 'pointer',
            padding: '0',
            lineHeight: '1',
            opacity: 0.8,
            transition: 'opacity 0.2s'
          }}
          onMouseEnter={(e) => e.target.style.opacity = '1'}
          onMouseLeave={(e) => e.target.style.opacity = '0.8'}
        >
          ×
        </button>
      </div>
    </div>
  );
}

